import { render } from "./MyTracker.vue?vue&type=template&id=4d85cdd3"
import script from "./MyTracker.vue?vue&type=script&lang=js"
export * from "./MyTracker.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__